import { Instagram } from "lucide-react";
import { EncabezadoSeccion, Reveal } from "../../shared/motion";

export default function Menciones({ datos, seccion }) {
  const menciones = datos.menciones || [];
  if (menciones.length === 0) return null;

  return (
    <section className="bt-seccion" aria-label={seccion.titulo}>
      <div className="bt-seccion-interior">
        <EncabezadoSeccion p="bt" etiqueta={seccion.etiqueta} titulo={seccion.titulo} centro testid="bt-titulo-menciones" />
        <div className="bt-menciones">
          {menciones.map((m, i) => (
            <Reveal key={i} delay={i * 0.07}>
              <figure className="bt-mencion" data-testid={`bt-mencion-${i}`}>
                <img className="bt-mencion-foto" src={m.foto} alt={`Fotografía de ${m.nombre}`} loading="lazy" />
                <figcaption>
                  <p className="bt-mencion-nombre">{m.nombre}</p>
                  <p className="bt-mencion-rol">{m.rol}</p>
                  {m.instagramUrl && (
                    <a
                      className="bt-mencion-ig"
                      href={m.instagramUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`Instagram de ${m.nombre}`}
                      data-testid={`bt-enlace-instagram-${i}`}
                    >
                      <Instagram strokeWidth={1.5} />
                    </a>
                  )}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
